export var blurs = {
  small: '27px',
  medium: '37px',
  large: '50px'
};
export var applyBlur = function applyBlur(_ref) {
  var blur = _ref.blur;
  return blur && "backdrop-filter: blur(".concat(blurs[blur], ");");
};